import Layout from "@views/layout";

const communityDashboardContentRouter = {
    path: "/dashboard/content",
    component: Layout,
    redirect: "/dashboard/content/distribution",
    meta: {
        title: "内容看板",
        icon: "el-icon-document",
    },
    children: [
        // {
        //     path: "distribution",
        //     name: "COMMUNITY_DASHBOARD_CONTENT_DISTRIBUTION",
        //     component: () => import("@views/dashboard/content/contentDistribution.vue"),
        //     meta: {
        //         title: "内容分布",
        //         keepAlive: false,
        //     },
        // },
        {
            path: "section-trend",
            name: "COMMUNITY_DASHBOARD_CONTENT_SECTION_TREND",
            component: () => import("@views/dashboard/content/sectionTrend.vue"),
            meta: {
                title: "板块活跃趋势",
                keepAlive: false,
            },
        },
        // {
        //     path: "ranking",
        //     name: "COMMUNITY_DASHBOARD_CONTENT_RANKING",
        //     component: () => import("@views/dashboard/content/contentRanking.vue"),
        //     meta: {
        //         title: "内容排行榜",
        //         keepAlive: false,
        //     },
        // },
    ],
};

export default communityDashboardContentRouter;
